import Vue from 'vue';
import AppState from '../AppState';
import User from '../User';
import Product from '../Product';
import Store from '../Store';
import Payment from '../Payment';
import Role from '../Role';
import Application from '../Application';
import Order from '../Order';
import System from '../System';

// This mixin module makes it really easy to instantly access all of our data modules from anywhere in our Vue app
export const store = {
	install(Vue) {
		Vue.prototype.$store = {
			User,
			Product,
			Store,
			Payment,
			AppState,
			Role,
			Application,
			Order,
			System
		};
		// Easy as that!
	}
};

// Install it on Vue
Vue.use(store);

// Also export a convenience function for removing all store data when we want to
export const wipeData = () => {
	Object.keys(Vue.prototype.$store).forEach(storeName => {
		if (Vue.prototype.$store[storeName].clearAll) {
			Vue.prototype.$store[storeName].clearAll();
		}
	});
};
